export const bookmarkAdd = {
    "v": "5.9.6",
    "fr": 60,
    "ip": 0,
    "op": 120,
    "w": 750,
    "h": 750,
    "nm": "Main render",
    "ddd": 0,
    "assets": [],
    "layers": [
      {
        "ddd": 0,
        "ind": 1,
        "ty": 4,
        "nm": "Layer 4",
        "parent": 3,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              305,
              367.324,
              0
            ],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [
              375,
              311.324,
              0
            ],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 0,
                      "s": [
                        {
                          "i": [
                            [
                              55.765,
                              0
                            ],
                            [
                              -55.765,
                              0
                            ]
                          ],
                          "o": [
                            [
                              55.765,
                              0
                            ],
                            [
                              -55.765,
                              0
                            ]
                          ],
                          "v": [
                            [
                              55.765,
                              0
                            ],
                            [
                              -55.765,
                              0
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "t": 10,
                      "s": [
                        {
                          "i": [
                            [
                              5.837,
                              -10.485
                            ],
                            [
                              -5.837,
                              10.485
                            ]
                          ],
                          "o": [
                            [
                              5.837,
                              -10.485
                            ],
                            [
                              -5.837,
                              10.485
                            ]
                          ],
                          "v": [
                            [
                              5.837,
                              -10.485
                            ],
                            [
                              -5.837,
                              10.485
                            ]
                          ],
                          "c": false
                        }
                      ]
                    }
                  ],
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false,
                "_render": true
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 3
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 4
                },
                "w": {
                  "a": 0,
                  "k": 35,
                  "ix": 5
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false,
                "_render": true
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    375,
                    311.324
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform",
                "_render": true
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false,
            "_render": true
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 0,
                      "s": [
                        {
                          "i": [
                            [
                              0,
                              -55.765
                            ],
                            [
                              0,
                              55.765
                            ]
                          ],
                          "o": [
                            [
                              0,
                              -55.765
                            ],
                            [
                              0,
                              55.765
                            ]
                          ],
                          "v": [
                            [
                              0,
                              -55.765
                            ],
                            [
                              0,
                              55.765
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "t": 10,
                      "s": [
                        {
                          "i": [
                            [
                              -10.485,
                              -5.837
                            ],
                            [
                              10.485,
                              5.837
                            ]
                          ],
                          "o": [
                            [
                              -10.485,
                              -5.837
                            ],
                            [
                              10.485,
                              5.837
                            ]
                          ],
                          "v": [
                            [
                              -10.485,
                              -5.837
                            ],
                            [
                              10.485,
                              5.837
                            ]
                          ],
                          "c": false
                        }
                      ]
                    }
                  ],
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false,
                "_render": true
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 3
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 4
                },
                "w": {
                  "a": 0,
                  "k": 35,
                  "ix": 5
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false,
                "_render": true
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    375,
                    311.324
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform",
                "_render": true
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false,
            "_render": true
          }
        ],
        "ip": 0,
        "op": 10,
        "st": 0,
        "ct": 1,
        "bm": 0,
        "completed": true
      },
      {
        "ddd": 0,
        "ind": 2,
        "ty": 4,
        "nm": "Layer 5",
        "parent": 3,
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 0,
            "k": [
              305,
              367.324,
              0
            ],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [
              375,
              311.324,
              0
            ],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 24,
                      "s": [
                        {
                          "i": [
                            [
                              5.837,
                              -10.485
                            ],
                            [
                              -5.837,
                              10.485
                            ]
                          ],
                          "o": [
                            [
                              5.837,
                              -10.485
                            ],
                            [
                              -5.837,
                              10.485
                            ]
                          ],
                          "v": [
                            [
                              5.837,
                              -10.485
                            ],
                            [
                              -5.837,
                              10.485
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 34,
                      "s": [
                        {
                          "i": [
                            [
                              60.282,
                              18.128
                            ],
                            [
                              -60.282,
                              -18.128
                            ]
                          ],
                          "o": [
                            [
                              60.282,
                              18.128
                            ],
                            [
                              -60.282,
                              -18.128
                            ]
                          ],
                          "v": [
                            [
                              60.282,
                              18.128
                            ],
                            [
                              -60.282,
                              -18.128
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "t": 44,
                      "s": [
                        {
                          "i": [
                            [
                              55.765,
                              0
                            ],
                            [
                              -55.765,
                              0
                            ]
                          ],
                          "o": [
                            [
                              55.765,
                              0
                            ],
                            [
                              -55.765,
                              0
                            ]
                          ],
                          "v": [
                            [
                              55.765,
                              0
                            ],
                            [
                              -55.765,
                              0
                            ]
                          ],
                          "c": false
                        }
                      ]
                    }
                  ],
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false,
                "_render": true
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 3
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 4
                },
                "w": {
                  "a": 0,
                  "k": 35,
                  "ix": 5
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false,
                "_render": true
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    375,
                    311.324
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform",
                "_render": true
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false,
            "_render": true
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 24,
                      "s": [
                        {
                          "i": [
                            [
                              -10.485,
                              -5.837
                            ],
                            [
                              10.485,
                              5.837
                            ]
                          ],
                          "o": [
                            [
                              -10.485,
                              -5.837
                            ],
                            [
                              10.485,
                              5.837
                            ]
                          ],
                          "v": [
                            [
                              -10.485,
                              -5.837
                            ],
                            [
                              10.485,
                              5.837
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 34,
                      "s": [
                        {
                          "i": [
                            [
                              18.128,
                              -60.282
                            ],
                            [
                              -18.128,
                              60.282
                            ]
                          ],
                          "o": [
                            [
                              18.128,
                              -60.282
                            ],
                            [
                              -18.128,
                              60.282
                            ]
                          ],
                          "v": [
                            [
                              18.128,
                              -60.282
                            ],
                            [
                              -18.128,
                              60.282
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "t": 44,
                      "s": [
                        {
                          "i": [
                            [
                              0,
                              -55.765
                            ],
                            [
                              0,
                              55.765
                            ]
                          ],
                          "o": [
                            [
                              0,
                              -55.765
                            ],
                            [
                              0,
                              55.765
                            ]
                          ],
                          "v": [
                            [
                              0,
                              -55.765
                            ],
                            [
                              0,
                              55.765
                            ]
                          ],
                          "c": false
                        }
                      ]
                    }
                  ],
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false,
                "_render": true
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 3
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 4
                },
                "w": {
                  "a": 0,
                  "k": 35,
                  "ix": 5
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false,
                "_render": true
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    375,
                    311.324
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform",
                "_render": true
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false,
            "_render": true
          }
        ],
        "ip": 24,
        "op": 204,
        "st": 24,
        "ct": 1,
        "bm": 0,
        "completed": true
      },
      {
        "ddd": 0,
        "ind": 3,
        "ty": 4,
        "nm": "Layer 1",
        "sr": 1,
        "ks": {
          "o": {
            "a": 0,
            "k": 100,
            "ix": 11
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 10
          },
          "p": {
            "a": 1,
            "k": [
              {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 0,
                "s": [
                  375,
                  375,
                  0
                ],
                "to": null,
                "ti": null
              },
              {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 10,
                "s": [
                  375,
                  411,
                  0
                ],
                "to": [
                  0,
                  0,
                  0
                ],
                "ti": [
                  0,
                  -3.167,
                  0
                ]
              },
              {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 20,
                "s": [
                  375,
                  411,
                  0
                ],
                "to": null,
                "ti": null
              },
              {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 30,
                "s": [
                  375,
                  328,
                  0
                ],
                "to": null,
                "ti": null
              },
              {
                "i": {
                  "x": 0.667,
                  "y": 1
                },
                "o": {
                  "x": 0.333,
                  "y": 0
                },
                "t": 40,
                "s": [
                  375,
                  389.413,
                  0
                ],
                "to": null,
                "ti": null
              },
              {
                "t": 50,
                "s": [
                  375,
                  375,
                  0
                ]
              }
            ],
            "ix": 2,
            "l": 2
          },
          "a": {
            "a": 0,
            "k": [
              375,
              375,
              0
            ],
            "ix": 1,
            "l": 2
          },
          "s": {
            "a": 0,
            "k": [
              100,
              100,
              100
            ],
            "ix": 6,
            "l": 2
          }
        },
        "ao": 0,
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 7,
                      "s": [
                        {
                          "i": [
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -165.795
                            ],
                            [
                              150.793,
                              167.296
                            ],
                            [
                              129.361,
                              197.38899999999998
                            ],
                            [
                              13.523,
                              115.48
                            ]
                          ],
                          "o": [
                            [
                              -150.793,
                              -165.795
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              125.828,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              186.296
                            ],
                            [
                              113.848,
                              186.42
                            ],
                            [
                              13.523,
                              115.48
                            ]
                          ],
                          "v": [
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              167.296
                            ],
                            [
                              113.848,
                              186.42
                            ],
                            [
                              13.523,
                              115.48
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 17,
                      "s": [
                        {
                          "i": [
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -164.057
                            ],
                            [
                              95.032,
                              -164.057
                            ],
                            [
                              150.793,
                              -151.047
                            ],
                            [
                              150.793,
                              215.296
                            ],
                            [
                              129.361,
                              245.38899999999998
                            ],
                            [
                              13.523,
                              163.48
                            ]
                          ],
                          "o": [
                            [
                              -150.793,
                              -151.047
                            ],
                            [
                              -95.032,
                              -164.057
                            ],
                            [
                              125.828,
                              -164.057
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              234.296
                            ],
                            [
                              113.848,
                              234.42
                            ],
                            [
                              13.523,
                              163.48
                            ]
                          ],
                          "v": [
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -164.057
                            ],
                            [
                              95.032,
                              -164.057
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              215.296
                            ],
                            [
                              113.848,
                              234.42
                            ],
                            [
                              13.523,
                              163.48
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 27,
                      "s": [
                        {
                          "i": [
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -164.057
                            ],
                            [
                              95.032,
                              -164.057
                            ],
                            [
                              150.793,
                              -151.047
                            ],
                            [
                              150.793,
                              215.296
                            ],
                            [
                              129.361,
                              245.38899999999998
                            ],
                            [
                              13.523,
                              163.48
                            ]
                          ],
                          "o": [
                            [
                              -150.793,
                              -151.047
                            ],
                            [
                              -95.032,
                              -164.057
                            ],
                            [
                              125.828,
                              -164.057
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              234.296
                            ],
                            [
                              113.848,
                              234.42
                            ],
                            [
                              13.523,
                              163.48
                            ]
                          ],
                          "v": [
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -164.057
                            ],
                            [
                              95.032,
                              -164.057
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              215.296
                            ],
                            [
                              113.848,
                              234.42
                            ],
                            [
                              13.523,
                              163.48
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 37,
                      "s": [
                        {
                          "i": [
                            [
                              -149.776,
                              -131.999
                            ],
                            [
                              -124.924,
                              -252.759
                            ],
                            [
                              95.936,
                              -252.759
                            ],
                            [
                              151.697,
                              -227.795
                            ],
                            [
                              149.585,
                              95.296
                            ],
                            [
                              128.154,
                              125.389
                            ],
                            [
                              12.315,
                              43.48
                            ]
                          ],
                          "o": [
                            [
                              -157.559,
                              -226.05700000000002
                            ],
                            [
                              -94.128,
                              -252.759
                            ],
                            [
                              126.732,
                              -252.759
                            ],
                            [
                              151.697,
                              -196.999
                            ],
                            [
                              149.585,
                              114.296
                            ],
                            [
                              112.641,
                              114.42
                            ],
                            [
                              12.315,
                              43.48
                            ]
                          ],
                          "v": [
                            [
                              -149.776,
                              -131.999
                            ],
                            [
                              -94.128,
                              -252.759
                            ],
                            [
                              95.936,
                              -252.759
                            ],
                            [
                              151.697,
                              -196.999
                            ],
                            [
                              149.585,
                              95.296
                            ],
                            [
                              112.641,
                              114.42
                            ],
                            [
                              12.315,
                              43.48
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 47,
                      "s": [
                        {
                          "i": [
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -174.949
                            ],
                            [
                              95.032,
                              -174.949
                            ],
                            [
                              150.793,
                              -157.063
                            ],
                            [
                              150.793,
                              181.696
                            ],
                            [
                              129.361,
                              211.789
                            ],
                            [
                              13.523,
                              129.88
                            ]
                          ],
                          "o": [
                            [
                              -150.793,
                              -157.063
                            ],
                            [
                              -95.032,
                              -174.949
                            ],
                            [
                              125.828,
                              -174.949
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              200.696
                            ],
                            [
                              113.848,
                              200.82
                            ],
                            [
                              13.523,
                              129.88
                            ]
                          ],
                          "v": [
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -174.949
                            ],
                            [
                              95.032,
                              -174.949
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              181.696
                            ],
                            [
                              113.848,
                              200.82
                            ],
                            [
                              13.523,
                              129.88
                            ]
                          ],
                          "c": false
                        }
                      ]
                    },
                    {
                      "t": 57,
                      "s": [
                        {
                          "i": [
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -165.795
                            ],
                            [
                              150.793,
                              167.296
                            ],
                            [
                              129.361,
                              197.38899999999998
                            ],
                            [
                              13.523,
                              115.48
                            ]
                          ],
                          "o": [
                            [
                              -150.793,
                              -165.795
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              125.828,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              186.296
                            ],
                            [
                              113.848,
                              186.42
                            ],
                            [
                              13.523,
                              115.48
                            ]
                          ],
                          "v": [
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              167.296
                            ],
                            [
                              113.848,
                              186.42
                            ],
                            [
                              13.523,
                              115.48
                            ]
                          ],
                          "c": false
                        }
                      ]
                    }
                  ],
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false,
                "_render": true
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 3
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 4
                },
                "w": {
                  "a": 0,
                  "k": 35,
                  "ix": 5
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false,
                "_render": true
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    444.559,
                    342.057
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform",
                "_render": true
              }
            ],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false,
            "_render": true
          },
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 1,
                  "k": [
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 4,
                      "s": [
                        {
                          "i": [
                            [
                              129.361,
                              197.38899999999998
                            ],
                            [
                              13.523,
                              115.48
                            ],
                            [
                              -5.4190000000000005,
                              109.74900000000001
                            ],
                            [
                              -113.848,
                              186.42
                            ],
                            [
                              -150.793,
                              186.296
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -165.795
                            ],
                            [
                              150.793,
                              167.296
                            ]
                          ],
                          "o": [
                            [
                              113.848,
                              186.42
                            ],
                            [
                              5.4190000000000005,
                              109.74900000000001
                            ],
                            [
                              -13.523,
                              115.48
                            ],
                            [
                              -129.361,
                              197.38899999999998
                            ],
                            [
                              -150.793,
                              167.296
                            ],
                            [
                              -150.793,
                              -165.795
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              125.828,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              186.296
                            ]
                          ],
                          "v": [
                            [
                              113.848,
                              186.42
                            ],
                            [
                              13.523,
                              115.48
                            ],
                            [
                              -13.523,
                              115.48
                            ],
                            [
                              -113.848,
                              186.42
                            ],
                            [
                              -150.793,
                              167.296
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              167.296
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 14,
                      "s": [
                        {
                          "i": [
                            [
                              129.209,
                              143.38899999999998
                            ],
                            [
                              13.371,
                              61.48
                            ],
                            [
                              -5.57,
                              55.748999999999995
                            ],
                            [
                              -114,
                              132.42
                            ],
                            [
                              -150.944,
                              132.296
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -165.795
                            ],
                            [
                              150.641,
                              113.296
                            ]
                          ],
                          "o": [
                            [
                              113.696,
                              132.42
                            ],
                            [
                              5.267000000000001,
                              55.748999999999995
                            ],
                            [
                              -13.674,
                              61.48
                            ],
                            [
                              -129.513,
                              143.38899999999998
                            ],
                            [
                              -150.944,
                              113.296
                            ],
                            [
                              -150.793,
                              -165.795
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              125.828,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.641,
                              132.296
                            ]
                          ],
                          "v": [
                            [
                              113.696,
                              132.42
                            ],
                            [
                              13.371,
                              61.48
                            ],
                            [
                              -13.674,
                              61.48
                            ],
                            [
                              -114,
                              132.42
                            ],
                            [
                              -150.944,
                              113.296
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.641,
                              113.296
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 24,
                      "s": [
                        {
                          "i": [
                            [
                              129.209,
                              143.38899999999998
                            ],
                            [
                              13.371,
                              61.48
                            ],
                            [
                              -5.57,
                              55.748999999999995
                            ],
                            [
                              -114,
                              132.42
                            ],
                            [
                              -150.944,
                              132.296
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -165.795
                            ],
                            [
                              150.641,
                              113.296
                            ]
                          ],
                          "o": [
                            [
                              113.696,
                              132.42
                            ],
                            [
                              5.267000000000001,
                              55.748999999999995
                            ],
                            [
                              -13.674,
                              61.48
                            ],
                            [
                              -129.513,
                              143.38899999999998
                            ],
                            [
                              -150.944,
                              113.296
                            ],
                            [
                              -150.793,
                              -165.795
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              125.828,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.641,
                              132.296
                            ]
                          ],
                          "v": [
                            [
                              113.696,
                              132.42
                            ],
                            [
                              13.371,
                              61.48
                            ],
                            [
                              -13.674,
                              61.48
                            ],
                            [
                              -114,
                              132.42
                            ],
                            [
                              -150.944,
                              113.296
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.641,
                              113.296
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 34,
                      "s": [
                        {
                          "i": [
                            [
                              128.884,
                              259.389
                            ],
                            [
                              13.045,
                              177.48
                            ],
                            [
                              -5.896000000000001,
                              171.749
                            ],
                            [
                              -114.325,
                              248.42
                            ],
                            [
                              -151.27,
                              248.296
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -165.795
                            ],
                            [
                              150.315,
                              229.296
                            ]
                          ],
                          "o": [
                            [
                              113.371,
                              248.42
                            ],
                            [
                              4.941000000000001,
                              171.749
                            ],
                            [
                              -14,
                              177.48
                            ],
                            [
                              -129.838,
                              259.389
                            ],
                            [
                              -151.27,
                              229.296
                            ],
                            [
                              -150.793,
                              -165.795
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              125.828,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.315,
                              248.296
                            ]
                          ],
                          "v": [
                            [
                              113.371,
                              248.42
                            ],
                            [
                              13.045,
                              177.48
                            ],
                            [
                              -14,
                              177.48
                            ],
                            [
                              -114.325,
                              248.42
                            ],
                            [
                              -151.27,
                              229.296
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.315,
                              229.296
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "i": {
                        "x": 0.667,
                        "y": 1
                      },
                      "o": {
                        "x": 0.333,
                        "y": 0
                      },
                      "t": 44,
                      "s": [
                        {
                          "i": [
                            [
                              129.315,
                              181.189
                            ],
                            [
                              13.477,
                              99.28
                            ],
                            [
                              -5.464,
                              93.549
                            ],
                            [
                              -113.894,
                              170.22
                            ],
                            [
                              -150.838,
                              170.096
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -165.795
                            ],
                            [
                              150.747,
                              151.096
                            ]
                          ],
                          "o": [
                            [
                              113.802,
                              170.22
                            ],
                            [
                              5.373000000000001,
                              93.549
                            ],
                            [
                              -13.568,
                              99.28
                            ],
                            [
                              -129.407,
                              181.189
                            ],
                            [
                              -150.838,
                              151.096
                            ],
                            [
                              -150.793,
                              -165.795
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              125.828,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.747,
                              170.096
                            ]
                          ],
                          "v": [
                            [
                              113.802,
                              170.22
                            ],
                            [
                              13.477,
                              99.28
                            ],
                            [
                              -13.568,
                              99.28
                            ],
                            [
                              -113.894,
                              170.22
                            ],
                            [
                              -150.838,
                              151.096
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.747,
                              151.096
                            ]
                          ],
                          "c": true
                        }
                      ]
                    },
                    {
                      "t": 54,
                      "s": [
                        {
                          "i": [
                            [
                              129.361,
                              197.38899999999998
                            ],
                            [
                              13.523,
                              115.48
                            ],
                            [
                              -5.4190000000000005,
                              109.74900000000001
                            ],
                            [
                              -113.848,
                              186.42
                            ],
                            [
                              -150.793,
                              186.296
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -125.828,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -165.795
                            ],
                            [
                              150.793,
                              167.296
                            ]
                          ],
                          "o": [
                            [
                              113.848,
                              186.42
                            ],
                            [
                              5.4190000000000005,
                              109.74900000000001
                            ],
                            [
                              -13.523,
                              115.48
                            ],
                            [
                              -129.361,
                              197.38899999999998
                            ],
                            [
                              -150.793,
                              167.296
                            ],
                            [
                              -150.793,
                              -165.795
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              125.828,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              186.296
                            ]
                          ],
                          "v": [
                            [
                              113.848,
                              186.42
                            ],
                            [
                              13.523,
                              115.48
                            ],
                            [
                              -13.523,
                              115.48
                            ],
                            [
                              -113.848,
                              186.42
                            ],
                            [
                              -150.793,
                              167.296
                            ],
                            [
                              -150.793,
                              -134.999
                            ],
                            [
                              -95.032,
                              -190.759
                            ],
                            [
                              95.032,
                              -190.759
                            ],
                            [
                              150.793,
                              -134.999
                            ],
                            [
                              150.793,
                              167.296
                            ]
                          ],
                          "c": true
                        }
                      ]
                    }
                  ],
                  "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false,
                "_render": true
              },
              {
                "ty": "st",
                "c": {
                  "a": 0,
                  "k": [
                    0,
                    0,
                    0,
                    1
                  ],
                  "ix": 3
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 4
                },
                "w": {
                  "a": 0,
                  "k": 35,
                  "ix": 5
                },
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false,
                "_render": true
              },
              {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [
                    305.441,
                    407.943
                  ],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [
                    0,
                    0
                  ],
                  "ix": 1
                },
                "s": {
                  "a": 0,
                  "k": [
                    100,
                    100
                  ],
                  "ix": 3
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 6
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 7
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 4
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 5
                },
                "nm": "Transform",
                "_render": true
              }
            ],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false,
            "_render": true
          }
        ],
        "ip": 0,
        "op": 180,
        "st": 0,
        "ct": 1,
        "bm": 0,
        "completed": true
      }
    ],
    "markers": [],
    "__complete": true
  }